module.exports = __webpack_public_path__ + "img/Carousel_3.be91bcf2.jpg";